// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"25ddaf16","453":"5cf7093f","777":"5e8d82e6"}[chunkId] + ".chunk.js";
};